import { render, staticRenderFns } from "./ProgramSettingsPage.vue?vue&type=template&id=7636e671&scoped=true"
import script from "./ProgramSettingsPage.vue?vue&type=script&lang=ts"
export * from "./ProgramSettingsPage.vue?vue&type=script&lang=ts"
import style0 from "./ProgramSettingsPage.vue?vue&type=style&index=0&id=7636e671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7636e671",
  null
  
)

export default component.exports